module.exports = __webpack_public_path__ + "img/czsc_12.584120b5.png";